import { afterNextRender, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ScreenSizeStore {
  private readonly platformId = inject(PLATFORM_ID);
  isMobileSize = signal<boolean>(false);

  constructor() {
    afterNextRender(() => {
      if (!isPlatformBrowser(this.platformId)) {
        return;
      }

      this.checkScreenSize();
      window.addEventListener('resize', this.checkScreenSize.bind(this));
    });
  }

  private checkScreenSize() {
    this.isMobileSize.set(window.innerWidth <= 768);
  }
}
